import { defineStore } from "pinia";
import http from "@/http";
import { LIST_AVULSO, ADD_AVULSO, UPDATE_AVULSO, DEL_AVULSO } from "@/http/url";

export const useAvulsoStore = defineStore("AvulsoStore", {
  state: () => {
    return {
      avulsos: [],
      loaded: false,
    };
  },
  
  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_AVULSOS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_AVULSO)
          .then((response) => {
            this.avulsos = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_AVULSO(avulso) {
      return http
        .post(ADD_AVULSO, avulso)
        .then((response) => this.avulsos.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_AVULSO(avulso) {
      return http.put(`${UPDATE_AVULSO + avulso.id}`, avulso);
    },

    REMOVER_AVULSO(id) {
      return http
        .delete(`${DEL_AVULSO + id}`)
        .then(() => (this.avulsos = this.avulsos.filter((avu) => avu.id != id)));
    },

  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getAvulsos() {      
      return this.avulsos;
    },

    getAvulsoLoad(state) {
      return state.loaded;
    },

    getFilterAvulsos: (state) => {
      return (filtro) => state.avulsos.filter((a) => !filtro || a.descricao.includes(filtro));
    },
  },
});